import { getDefaultFormValues } from "shared/Scan/helpers";
import { ScanFormFields } from "shared/Scan/types";

import { ScanSettingsItem } from "../gql";

export type ScanSettingsWorkerPoolFormFields = Pick<ScanFormFields, "workerPoolId">;

export const getFormDefaultValues = (
  scanSettings: ScanSettingsItem
): ScanSettingsWorkerPoolFormFields => {
  const { workerPoolId } = getDefaultFormValues(scanSettings);
  return { workerPoolId };
};
